<template>
  <div
    class="tiss-field"
    :style="{ width: largura, height: altura, background: bgColor }"
    style="
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;   
    border-width: 1px;
    -webkit-print-color-adjust: exact;
    margin:0mm 1mm;"
  >
    <div class="ml-1 font-weight-bold" style="font-size: 6pt; ">
      <span v-html="title"></span>
    </div>
    <div class="mx-3" style="position: relative; top: -5px;">
      <span :style="{'font-size': fontSize}" v-html="value"></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      display: "",
      bgColor: "white"
    };
  },

  props: {
    title: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    largura: {
      type: String,
      default: "7cm"
    },
    altura: {
      type: String,
      default: "0.7cm"
    },
    obrigatorio: {
      type: Boolean,
      default: true
    },
    fontSize: {
      type: String,
      default: "10pt"
    }
  },
  created() {
    if (this.obrigatorio) {
      this.display += "*";
    }
  }
};
</script>

<style scoped>
.tiss-box {
  border-style: solid;
  border-width: 1px;
  -webkit-print-color-adjust: exact;
}
</style>
